// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__gYBLX","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__ZhZqF"};